import { render, staticRenderFns } from "./PurchaseInvoiceStatusMessage.vue?vue&type=template&id=78f362e4"
import script from "./PurchaseInvoiceStatusMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseInvoiceStatusMessage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports